module.exports = __webpack_public_path__ + "img/dice-d12.24e93bfe.svg";